import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components/macro'

import { IconArrowLeft } from '@loadsmart/icons'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { screen } from 'legacy/styles/screen'

export const BreadcrumbContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-wrap: nowrap;
  align-items: center;
  width: auto;
  padding: 12px 0;
  overflow: auto;

  > :nth-child(n + 3) {
    &::before {
      margin: 0 10px;

      font-weight: 400;

      content: '/';
    }
  }

  > :last-child {
    color: ${getToken('color-neutral-darker')};
    font-weight: bold;
  }

  ${screen.md} {
    padding: 16px 0;
  }
`

export const BreadcrumbArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 35px;
  height: 35px;
  margin-right: 10px;

  background-color: ${getToken('color-neutral-lighter')};
  border-radius: 50%;

  :hover {
    opacity: 0.7;
  }
`

export const StyledArrowRight = styled(IconArrowLeft)`
  color: ${getToken('color-neutral-dark')};
`

export const BreadcrumbItem = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;

  color: ${getToken('color-neutral-darkest')};
  font-weight: 400;
  font-size: 20px;
`

const BreadcrumbLinkCss = css`
  display: flex;

  & > ${BreadcrumbItem} {
    border-bottom: ${getToken('color-neutral-darkest')} solid 1px;
  }
`

export const BreadcrumbLink = styled(Link)`
  ${BreadcrumbLinkCss};
`
export const BreadcrumbAnchor = styled.a`
  ${BreadcrumbLinkCss};
`

export function BreadcrumbArrow() {
  return (
    <BreadcrumbArrowContainer>
      <StyledArrowRight width={19} height={15} />
    </BreadcrumbArrowContainer>
  )
}

export const BreadcrumbParent = styled.span`
  visibility: visible;
`
